"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogSearchStore = exports.defaultCatalogSelectionCriteria = exports.defaultCatalogPagination = void 0;
const mobx_1 = require("mobx");
const searchAPI = __importStar(require("@App/api/routes/search"));
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const lodash_1 = require("lodash");
const find_page_on_limit_change_1 = require("@App/helpers/pagination/find-page-on-limit-change");
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const get_search_query_1 = require("@App/helpers/get-search-query");
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
const convert_new_search_terms_1 = require("@App/helpers/convert-new-search-terms");
const is_hold_status_1 = require("@App/helpers/work-entities/utils/is-hold-status");
const sidebar_download_type_1 = require("@App/enum/sidebar-download-type");
const check_is_empty_object_1 = require("@App/helpers/check-is-empty-object");
exports.defaultCatalogPagination = {
    page: 1,
    limit: 10,
};
exports.defaultCatalogSelectionCriteria = [
    {
        id: get_search_query_1.SEARCH_CATALOG_WORK_OPTIONS[0].id,
        selectedOption: get_search_query_1.SEARCH_CATALOG_WORK_OPTIONS[0],
        searchTerm: '',
        isFixed: true,
    },
];
const nonExportableKeys = ['recordingName', 'isrc', 'recordingTitle', 'holdTypeId'];
class CatalogSearchStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_worksRightsHolder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_worksRightsHolderPaginationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "searchCriteriaStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_pagination", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: exports.defaultCatalogPagination
        });
        Object.defineProperty(this, "_isSearchExportable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_catalogSelectionQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentSearchFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { holdTypeId: [] }
        });
        Object.defineProperty(this, "searchForWorks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callBackPagination) => __awaiter(this, void 0, void 0, function* () {
                if (callBackPagination) {
                    this._pagination = callBackPagination;
                }
                const query = Object.assign(Object.assign({}, this._catalogSelectionQuery), this._currentSearchFilters);
                if (this._catalogSelectionQuery === undefined) {
                    query.sort = { field: 'title.alphanum' };
                }
                yield this.getWorksRightsHolder(this._pagination, query);
                const page = this._pagination.page ? this._pagination.page : 1;
                this.setCurrentPaginationPage(page);
                (0, mobx_1.runInAction)(() => {
                    this._isSearchExportable = this.canSearchTermBeExported();
                });
            })
        });
        Object.defineProperty(this, "changeSearchResultsLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (newLimit) => {
                const newPage = (0, find_page_on_limit_change_1.findPageOnLimitChange)(this._pagination, this._worksRightsHolder ? this._worksRightsHolder.count : 1, newLimit);
                this.setCurrentPaginationLimit(newLimit);
                this.setCurrentPaginationPage(newPage);
                const pagination = {
                    page: newPage,
                    limit: newLimit,
                };
                return this.searchForWorks(pagination);
            }
        });
        Object.defineProperty(this, "fetchClaimedShares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (!this.emptyResults && this.worksRightsHolder) {
                    // If the above computed value is true, then worksRightsHolder.works exists.
                    const workIds = this.worksRightsHolder.works
                        .map((work) => work.id)
                        .filter((workId) => !!workId);
                    this.rootStore.rightsholderStore.loadClaimedShares(workIds).then();
                }
            }
        });
        Object.defineProperty(this, "getHoldStatusFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (filters) => {
                let holdStatusFilter = [];
                Object.entries(filters).forEach((entry) => {
                    if (entry[1]) {
                        holdStatusFilter = [...holdStatusFilter, ...(0, is_hold_status_1.getHoldTypeIdFromName)(entry[0])];
                    }
                });
                return { holdTypeId: holdStatusFilter };
            }
        });
        /** Check if searchFilterValue is a field that cannot be exported and see if singleSearchValue is populated */
        Object.defineProperty(this, "canSearchTermBeExported", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.emptyResults) {
                    return false;
                }
                if (!this._catalogSelectionQuery) {
                    return true;
                }
                return ![...Object.entries(this._catalogSelectionQuery), ...Object.entries(this._currentSearchFilters)]
                    .filter(([, value]) => !!value)
                    .filter(([, value]) => !(Array.isArray(value) && value.length === 0))
                    .map(([key]) => key)
                    .some((key) => nonExportableKeys.includes(key));
            }
        });
        (0, mobx_1.makeObservable)(this, {
            _worksRightsHolder: mobx_1.observable,
            _worksRightsHolderPaginationInfo: mobx_1.observable,
            _pagination: mobx_1.observable,
            _isSearchExportable: mobx_1.observable,
            _currentSearchFilters: mobx_1.observable,
            emptyResults: mobx_1.computed,
            setCurrentPaginationLimit: mobx_1.action,
            setCurrentPaginationPage: mobx_1.action,
            setCurrentSearchFilters: mobx_1.action,
            searchForWorks: mobx_1.action,
            destroyPagination: mobx_1.action,
            destroyCurrentSearchFilter: mobx_1.action,
            destroyWorksRightsHolderPaginationInfo: mobx_1.action,
            destroyWorksRightsHolder: mobx_1.action,
            destroyCatalogCriteria: mobx_1.action,
            destroyCurrentPage: mobx_1.action,
        });
        this.rootStore = rootStore;
        this.resetSearchCriteriaStore();
    }
    get pagination() {
        return this._pagination;
    }
    get isSearchExportable() {
        return this._isSearchExportable;
    }
    get limit() {
        return this._pagination.limit ? this._pagination.limit : 10;
    }
    get emptyResults() {
        var _a, _b;
        return !((_b = (_a = this._worksRightsHolder) === null || _a === void 0 ? void 0 : _a.works) === null || _b === void 0 ? void 0 : _b.length);
    }
    get worksRightsHolder() {
        return this._worksRightsHolder;
    }
    get worksRightsHolderPaginationInfo() {
        return this._worksRightsHolderPaginationInfo;
    }
    get catalogSelectionSearchQuery() {
        return this._catalogSelectionQuery;
    }
    get sidebarDownloadType() {
        return sidebar_download_type_1.SidebarDownloadType.CatalogExport;
    }
    setCurrentSearchFilters(filters) {
        this._currentSearchFilters = this.getHoldStatusFilters(filters);
    }
    setCurrentPaginationLimit(limit) {
        this._pagination.limit = limit;
    }
    setCurrentPaginationPage(page) {
        this._pagination.page = page;
    }
    setCatalogSelectionSearchQuery(catalogSelectionQuery) {
        this._catalogSelectionQuery = catalogSelectionQuery;
    }
    resetSearchCriteriaStore() {
        const maxCriteria = 8;
        this.searchCriteriaStore = new search_criteria_store_1.default(exports.defaultCatalogSelectionCriteria, get_search_query_1.SEARCH_CATALOG_WORK_OPTIONS, search_option_type_1.SearchOptionType.primary, required_criteria_1.RequiredCriteria.primaryFilter, maxCriteria, ['MLC_OVERCLAIM', 'MLC_DISPUTE']);
    }
    resetStore() {
        this.resetSearchCriteriaStore();
        this.destroyWorksRightsHolderPaginationInfo();
        this.destroyWorksRightsHolder();
        this.destroyPagination();
    }
    getWorksRightsHolder(pagination, search) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.getWorksRightsHolderApiCall(this.rootStore.rightsholderStore.currentRightsholderId, pagination, search);
                (0, mobx_1.runInAction)(() => {
                    this._worksRightsHolder = response;
                    if (pagination.limit && pagination.page && response) {
                        const data = (0, calc_num_pages_1.calcNumPages)(response.count, pagination.limit, pagination.page);
                        if (!data) {
                            return;
                        }
                        this._worksRightsHolderPaginationInfo = data;
                    }
                });
                this.fetchClaimedShares();
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
            }
        });
    }
    getWorksRightsHolderApiCall(rightsHolderId, pagination, search) {
        return __awaiter(this, void 0, void 0, function* () {
            // get info with search
            // TODO - refactor this mess when we remove old search
            if (!search || (0, check_is_empty_object_1.isEmptyObject)((0, lodash_1.omit)((0, lodash_1.omit)(search, 'sort'), 'holdTypeId'))) {
                pagination.sort = [
                    { field: 'title.keyword', direction: 'asc' },
                    { field: 'property_id', direction: 'asc' },
                ];
            }
            const searchResponse = yield searchAPI.searchWorksRH(rightsHolderId, pagination, search ? (0, convert_new_search_terms_1.convertNewSearchTerms)(search) : {});
            return {
                count: searchResponse.data.totalElements,
                works: searchResponse.data.content,
                error: undefined,
            };
        });
    }
    destroyWorksRightsHolderPaginationInfo() {
        this._worksRightsHolderPaginationInfo = undefined;
    }
    destroyWorksRightsHolder() {
        this._worksRightsHolder = undefined;
    }
    destroyPagination() {
        this._pagination = exports.defaultCatalogPagination;
    }
    destroyCurrentPage() {
        this._pagination.page = 1;
    }
    destroyCatalogCriteria() {
        this._pagination = exports.defaultCatalogPagination;
        this._catalogSelectionQuery = {};
        this._worksRightsHolder = undefined;
        this._worksRightsHolderPaginationInfo = undefined;
    }
    destroyCurrentSearchFilter() {
        this._currentSearchFilters = {
            holdTypeId: [],
        };
    }
}
exports.CatalogSearchStore = CatalogSearchStore;
